export class CashregisterStockFormFields {
    url: string = '';
    sku: string = '';
    barcode: string = '';
    code: string = '';
    name: string = '';
}
